var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarlinPond = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 100,
    viewBox: "0 0 149 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3037 2.95559C95.3648 2.01562 94.2497 1.27063 93.0223 0.763415C91.7949 0.256204 90.4795 -0.0032264 89.1516 3.02847e-05H89.1257C87.7952 -0.000265444 86.4779 0.264511 85.2506 0.778929C84.0233 1.29335 82.9106 2.04712 81.9773 2.99633L2.95269 82.4778C2.01151 83.4183 1.26596 84.5363 0.759154 85.7671C0.252351 86.9978 -0.00564338 88.317 9.36176e-05 89.6482C0.00749362 92.3556 1.06939 94.9 2.98599 96.8111C3.92268 97.7509 5.03589 98.4959 6.26147 99.0032C7.48705 99.5104 8.80079 99.7699 10.127 99.7667C12.8391 99.7667 15.3958 98.7037 17.3124 96.7815L96.3333 17.2963C98.2246 15.3883 99.2834 12.8077 99.2778 10.1198C99.2723 7.43195 98.2028 4.8558 96.3037 2.95559V2.95559Z",
    fill: "#2DB8E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.184 0.967137C140.332 0.192711 138.291 -0.00985117 136.323 0.38546C134.355 0.780771 132.55 1.75591 131.14 3.18566L52.1076 82.6745C50.2146 84.5822 49.1552 87.1638 49.1621 89.8526C49.1691 92.5414 50.2417 95.1175 52.1446 97.0153C54.0514 98.9099 56.6313 99.9698 59.318 99.9621C62.0047 99.9545 64.5786 98.88 66.4747 96.9745L128.183 34.9079V89.8227C128.185 92.5116 129.253 95.0898 131.153 96.9911C133.052 98.8924 135.628 99.9615 138.314 99.9634C141 99.9615 143.576 98.8924 145.475 96.9911C147.375 95.0898 148.443 92.5116 148.444 89.8227V10.3412C148.45 8.33269 147.858 6.36802 146.743 4.69825C145.628 3.02848 144.04 1.72944 142.184 0.967137V0.967137Z",
    fill: "#3840C7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarlinPond);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/marlin-pond.e9120a201ac3b798f443729992d8b56b.svg";